<app-jurormenu></app-jurormenu>
<div class="row">
    <div>
        <ng-container *ngIf="1">
            Submission ID,Rating,First Name,Last Name,Street,City,State,Zip,Country,Phone Number,Email,Title,Price,Unframed Width,Unframed Height,Filename
        </ng-container>
        <div style="margin-left: 10px; font-size: 10px">[
        <ng-container *ngFor="let entry of entries">
            <div *ngIf="0 && entry.jurorSelection > 0 && entry.jurorSelection <= 2">
                {{ toShowEntry(entry) | json }},
            </div>
            <div *ngIf="entry.jurorSelection > 0 && entry.jurorSelection <= 2">
                {{ entry.submissionID }},
                {{ entry.jurorSelection }},
                {{ entry.raw.FirstName | titlecase }},
                {{ entry.raw.LastName | titlecase }},
                {{ strip(entry.raw.Address) }},
                {{ strip(entry.raw.City) | titlecase }},
                {{ entry.raw.State | uppercase }},
                {{ entry.raw.Postal }},
                {{ entry.raw.Country | titlecase }},
                {{ entry.raw.PhoneNumber }},
                {{ entry.raw.Email }},
                <ng-container *ngIf="entry.jurorSelection === 1">
                    {{ strip(entry.raw.Title1) }},
                    {{ entry.raw.Price1 }},
                    {{ entry.raw.UnframedWidth1 }},
                    {{ entry.raw.UnframedHeight1 }},
                    {{ strip(entry.raw.Url1) }}
                </ng-container>
                <ng-container *ngIf="entry.jurorSelection === 2">
                    {{ strip(entry.raw.Title2) }},
                    {{ entry.raw.Price2 }},
                    {{ entry.raw.UnframedWidth2 }},
                    {{ entry.raw.UnframedHeight2 }},
                    {{ strip(entry.raw.Url2) }}
                </ng-container>
            </div>
        </ng-container>
        ]
    </div>
    </div>
</div>
